<template>
  <div class="discipline-explanatory-cell">
    <c-button
      v-if="
        record.explanatory.value === 'available' && record.isFined.toString() === '0' && record.explanatoryWriteAccess
      "
      class="m-auto discipline-explanatory-cell-need-write"
      size="small"
      label="Написать"
      @click="isShowWriteExplanatoryModal = true"
    />
    <template v-if="record.explanatory.value === 'expired'">Просрочено</template>
    <template v-if="record.isFined.toString() === '1'">Выписан штраф</template>
    <c-button
      v-if="record.explanatory.value === 'explanatory'"
      key="explanatory"
      v-b-popover.html="{
        container: '#app',
        trigger: 'hover blur',
        content: 'Просмотр объяснительной',
        placement: 'top',
      }"
      size="iconic"
      icon="explanatory"
      @click="isShowExplanatoryModal = true"
    />
    <div class="m-show-explanatory">
      <b-modal
        id="discipline-show-explanatory-modal"
        v-model="isShowExplanatoryModal"
        size="custom-size"
        no-enforce-focus
        centered
        hide-footer
        hide-header
        @show="onShowExplanatoryModal"
        @close="isShowExplanatoryModal = false"
      >
        <svg
          class="m-show-explanatory-close"
          width="15"
          height="16"
          viewBox="0 0 15 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          @click="isShowExplanatoryModal = false"
        >
          <path
            d="M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z"
            fill="#8E9CBB"
          />
          <path
            d="M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z"
            fill="#8E9CBB"
          />
        </svg>
        <div class="m-show-explanatory-title">Просмотр объяснительной</div>
        <div v-if="isShowExplanatoryModalLoaded" class="m-show-explanatory-loader">
          <font-awesome-icon :icon="icon" spin />
        </div>
        <div v-if="!isShowExplanatoryModalLoaded" class="m-show-explanatory-fullname">
          {{ workerNameShowExplanatoryModal }}, <span>{{ dateShowExplanatoryModal }}</span>
        </div>
        <div v-if="!isShowExplanatoryModalLoaded" class="m-show-explanatory-request-header">
          {{ record.reason.value }}
        </div>
        <div v-if="!isShowExplanatoryModalLoaded" class="position-relative">
          <div id="m-show-explanatory-content-shadow-top" class="m-show-explanatory-content-shadow-top"></div>
          <div
            id="m-show-explanatory-content"
            class="m-show-explanatory-content"
            @scroll="setShadowsShowExplanatoryModalItems"
          >
            <div class="m-show-explanatory-content-mr">
              <div class="m-show-explanatory-fullname m-show-explanatory-fullname-mobile">
                {{ workerNameShowExplanatoryModal }}, <span>{{ dateShowExplanatoryModal }}</span>
              </div>
              <div class="m-show-explanatory-request-header m-show-explanatory-request-header-mobile">
                {{ record.reason.value }}
              </div>
              <div class="m-show-explanatory-content-text" v-html="textShowExplanatoryModal" >
                {{ textShowExplanatoryModal }}
              </div>
              <viewer class="m-show-explanatory-content-images" :photos="imagesExplanatoryModal.map((img) => img.src)">
                <img
                  v-for="item in imagesExplanatoryModal"
                  :key="item.src"
                  class="m-show-explanatory-content-images-img"
                  :src="item.src"
                  @click="onClickImageExplanatoryShowModal"
                />
              </viewer>
            </div>
          </div>
          <div id="m-show-explanatory-content-shadow-bottom" class="m-show-explanatory-content-shadow-bottom"></div>
        </div>
        <c-button class="m-show-explanatory-button-close" label="Закрыть" @click="isShowExplanatoryModal = false" />
      </b-modal>
    </div>
    <div class="m-write-explanatory">
      <b-modal
        id="discipline-write-explanatory-modal"
        v-model="isShowWriteExplanatoryModal"
        size="custom-size"
        no-enforce-focus
        centered
        hide-footer
        hide-header
        @close="isShowWriteExplanatoryModal = false"
      >
        <svg
          class="m-write-explanatory-close"
          width="15"
          height="16"
          viewBox="0 0 15 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          @click="isShowWriteExplanatoryModal = false"
        >
          <path
            d="M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z"
            fill="#8E9CBB"
          />
          <path
            d="M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z"
            fill="#8E9CBB"
          />
        </svg>
        <div class="m-write-explanatory-title">Отправить объяснительную</div>
        <div class="position-relative">
          <div id="m-write-explanatory-content-shadow-top" class="m-write-explanatory-content-shadow-top"></div>
          <div
            id="m-write-explanatory-content"
            class="m-write-explanatory-content"
            @scroll="setShadowsWriteExplanatoryModalItems"
          >
            <div id="m-write-explanatory-editor" class="m-write-explanatory-editor" @focusin.stop>
              <editor v-model="explanatoryTextLocal" :api-key="tinymceApiKey" :init="tinymceConfig" />
            </div>
            <viewer
              v-if="modalWriteExplanatoryAppendImages.length > 0"
              ref="writeExplanatoryModalViewer"
              class="m-write-explanatory-photos"
              :images="modalWriteExplanatoryAppendImages.map((img) => img.url)"
            >
              <div
                v-for="(img, index) in modalWriteExplanatoryAppendImages"
                :key="`${index}-img`"
                class="m-write-explanatory-photos-item"
              >
                <div class="d-flex flex-column justify-content-center">
                  <img class="m-write-explanatory-photos-item-photo" :src="img.url" />
                  <div class="m-write-explanatory-photos-item-name">{{ img.name }}</div>
                </div>
                <c-button
                  v-b-popover.html="{
                    container: '#app',
                    trigger: 'hover blur',
                    content: 'Удалить',
                    placement: 'top',
                  }"
                  class="m-write-explanatory-photos-item-trash"
                  size="iconic"
                  icon="trash"
                  @click="removeImage(index, img.name)"
                />
              </div>
            </viewer>
          </div>
          <div id="m-write-explanatory-content-shadow-bottom" class="m-write-explanatory-content-shadow-bottom"></div>
        </div>
        <c-button
          class="m-write-explanatory-add-photo"
          :disabled="modalWriteExplanatoryAppendImages.length === 20"
          :class="{ 'm-write-explanatory-add-photo-photos-empty': modalWriteExplanatoryAppendImages.length === 0 }"
          size="small"
          :icon="{ icon: 'plus', color: 'primary' }"
          label="Добавить фото"
          @click="chooseFiles()"
        />
        <div class="m-write-explanatory-error-message">
          <svg
            v-if="isModalWriteExplanatorySubmitError || isModalWriteExplanatoryFileLarge"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="7" cy="7" r="6.5" fill="white" stroke="#FF238D"></circle>
            <circle cx="7" cy="10" r="1" fill="#FF238D"></circle>
            <rect x="6" y="3" width="2" height="5" rx="1" fill="#FF238D"></rect>
          </svg>
          <div class="m-write-explanatory-error-message-text">
            {{ errorText }}
          </div>
        </div>
        <input
          id="m-write-file-upload"
          ref="writeExplanatoryFileUpload"
          name="attachment[]"
          multiple
          type="file"
          accept="image/gif, image/jpeg, image/png, image/jpg"
          hidden
          @change="onFileChange"
        />
        <div class="m-write-explanatory-buttons">
          <c-button
            class="m-write-explanatory-buttons-cancel"
            label="Отменить"
            @click="isShowWriteExplanatoryModal = false"
          />
          <c-button
            class="m-write-explanatory-buttons-submit"
            color="primary"
            label="Сохранить"
            @click="submitExplanatory"
          />
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import Editor from "@tinymce/tinymce-vue";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { tinymceConfig, tinymceApiKey } from "@/constants/tinymceConfig";
import Button from "@/components/controls2/Button";

export default {
  name: "discipline-explanatory-cell",
  components: {
    "c-button": Button,
    Editor,
    FontAwesomeIcon,
  },
  props: ["cellValue", "record"],
  data() {
    return {
      icon: faSpinner,
      isShowExplanatoryModalLoaded: false,
      isShowExplanatoryModal: false,
      isShowWriteExplanatoryModal: false,
      imagesExplanatoryModal: [],
      workerNameShowExplanatoryModal: "",
      dateShowExplanatoryModal: "",
      textShowExplanatoryModal: "",

      isModalWriteExplanatoryFileLarge: false,
      isModalWriteExplanatorySubmitError: false,
      explanatoryTextLocal: "",
      modalWriteExplanatoryAppendImages: [],
      modalWriteExplanatoryFormDataFiles: [],
      tinymceConfig,
      tinymceApiKey,
    };
  },
  computed: {
    errorText() {
      if (this.isModalWriteExplanatorySubmitError) {
        return "Необходимо ввести текст или прикрепить файл";
      }
      if (this.isModalWriteExplanatoryFileLarge) {
        return "Файл не может быть больше 5МБ";
      }
      return "";
    },
  },
  watch: {
    isShowWriteExplanatoryModal(value) {
      if (!value) {
        setTimeout(() => {
          this.modalWriteExplanatoryAppendImages = [];
          this.modalWriteExplanatoryFormDataFiles = [];
          this.explanatoryTextLocal = "";
        }, 250);
      }
    },
    modalWriteExplanatoryAppendImages(value) {
      setTimeout(() => {
        const viewer = document.getElementById("viewer1");
        if (this.isShowWriteExplanatoryModal && viewer) {
          if (value.length > 1) {
            viewer.classList.add("viewer-slider-write-explanatory");
          } else {
            viewer.classList.remove("viewer-slider-write-explanatory");
          }
        }
      }, 500);

      if (value.length > 0 && this.isModalWriteExplanatorySubmitError) {
        this.isModalWriteExplanatorySubmitError = false;
      }

      if (value.length > 0 && this.isModalWriteExplanatoryFileLarge) {
        this.isModalWriteExplanatoryFileLarge = false;
      }
    },
    // imagesExplanatoryModal(value) {
    //   setTimeout(() => {
    //     let viewer = document.getElementById('viewer1')
    //     if (viewer) {
    //       if (value.length > 1) {
    //         viewer.classList.add('viewer-slider-write-explanatory')
    //       } else {
    //         viewer.classList.remove('viewer-slider-write-explanatory')
    //       }
    //     }
    //   }, 500)
    // }

    explanatoryTextLocal(value) {
      if (value.length > 0 && this.isModalWriteExplanatorySubmitError) {
        this.isModalWriteExplanatorySubmitError = false;
      }
    },
  },
  mounted() {
    this.setShadowsShowExplanatoryModalItems();
    this.setShadowsWriteExplanatoryModalItems();
  },
  methods: {
    onShowExplanatoryModal() {
      this.isShowExplanatoryModalLoaded = true;

      const workerId = this.$route.params.id;
      let penaltyType = "";
      let penaltyId = "";
      if (this.record.ubp_id !== null) {
        penaltyId = this.record.ubp_id;
        penaltyType = "fine";
      } else if (this.record.foul_id !== null) {
        penaltyId = this.record.foul_id;
        penaltyType = "foul";
      }

      this.$store
        .dispatch("personalEmployee/showExplanatory", {
          penaltyId,
          penaltyType,
          workerId,
        })
        .then((result) => {
          const data = result.response;
          this.workerNameShowExplanatoryModal = data.worker;
          this.dateShowExplanatoryModal = data.date;
          this.textShowExplanatoryModal = data.text;
          this.imagesExplanatoryModal = data.files.map((file) => ({
            src: `images/${file}`,
          }));
          setTimeout(() => {
            this.isShowExplanatoryModalLoaded = false;
          }, 400);
        });
    },
    onClickImageExplanatoryShowModal() {
      setTimeout(() => {
        const viewer = document.getElementById("viewer1");
        if (this.imagesExplanatoryModal.length > 1) {
          viewer.classList.add("viewer-slider-write-explanatory");
        } else {
          viewer.classList.remove("viewer-slider-write-explanatory");
        }
      }, 500);
    },
    setShadowsShowExplanatoryModalItems() {
      const shadowTopElement = document.getElementById("m-show-explanatory-content-shadow-top");
      const shadowBottomElement = document.getElementById("m-show-explanatory-content-shadow-bottom");
      const scrollableElement = document.getElementById("m-show-explanatory-content");
      if (scrollableElement !== null) {
        if (scrollableElement.scrollHeight > scrollableElement.clientHeight) {
          // top shadow items
          if (scrollableElement.scrollTop !== 0) {
            shadowTopElement.classList.add("m-show-explanatory-content-shadow-top-active");
          } else if (scrollableElement.scrollTop === 0) {
            shadowTopElement.classList.remove("m-show-explanatory-content-shadow-top-active");
          }
          // bottom shadow items
          if (scrollableElement.scrollTop + scrollableElement.clientHeight !== scrollableElement.scrollHeight) {
            shadowBottomElement.classList.add("m-show-explanatory-content-shadow-bottom-active");
          } else {
            shadowBottomElement.classList.remove("m-show-explanatory-content-shadow-bottom-active");
          }
        } else {
          shadowTopElement.classList.remove("m-show-explanatory-content-shadow-top-active");
          shadowBottomElement.classList.remove("m-show-explanatory-content-shadow-bottom-active");
        }
      }
    },
    setShadowsWriteExplanatoryModalItems() {
      const shadowTopElement = document.getElementById("m-write-explanatory-content-shadow-top");
      const shadowBottomElement = document.getElementById("m-write-explanatory-content-shadow-bottom");
      const scrollableElement = document.getElementById("m-write-explanatory-content");
      if (scrollableElement !== null) {
        if (scrollableElement.scrollHeight > scrollableElement.clientHeight) {
          // top shadow items
          if (scrollableElement.scrollTop !== 0) {
            shadowTopElement.classList.add("m-write-explanatory-content-shadow-top-active");
          } else if (scrollableElement.scrollTop === 0) {
            shadowTopElement.classList.remove("m-write-explanatory-content-shadow-top-active");
          }
          // bottom shadow items
          if (scrollableElement.scrollTop + scrollableElement.clientHeight !== scrollableElement.scrollHeight) {
            shadowBottomElement.classList.add("m-write-explanatory-content-shadow-bottom-active");
          } else {
            shadowBottomElement.classList.remove("m-write-explanatory-content-shadow-bottom-active");
          }
        } else {
          shadowTopElement.classList.remove("m-write-explanatory-content-shadow-top-active");
          shadowBottomElement.classList.remove("m-write-explanatory-content-shadow-bottom-active");
        }
      }
    },
    chooseFiles() {
      document.getElementById("m-write-file-upload").click();
    },
    onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      // Добавляем файл в файл-лист для отправки формы
      const newFileList = Array.from(files);
      newFileList.forEach((file, index) => {
        if (file.size > 500000) {
          newFileList.splice(index, 1);
          this.isModalWriteExplanatoryFileLarge = true;
          console.log("Размер файла не может превышать 5мб");
        } else {
          this.modalWriteExplanatoryFormDataFiles.push(file);
        }
      });
      this.createImage(newFileList);
    },
    createImage(files) {
      const vm = this;
      for (let index = 0; index < files.length; index++) {
        const reader = new FileReader();
        reader.onload = (event) => {
          const { name } = files[index];
          const url = event.target.result;
          if (vm.modalWriteExplanatoryAppendImages.length < 20) {
            vm.modalWriteExplanatoryAppendImages.push({ url, name });
          }
        };
        reader.readAsDataURL(files[index]);
      }
    },
    removeImage(index, name) {
      this.modalWriteExplanatoryAppendImages.splice(index, 1);

      const b = this.modalWriteExplanatoryFormDataFiles.findIndex((file) => file.name === name);

      if (b !== -1) this.modalWriteExplanatoryFormDataFiles.splice(b, 1);
    },
    submitExplanatory() {
      if (this.modalWriteExplanatoryAppendImages.length === 0 && this.explanatoryTextLocal.length === 0) {
        this.isModalWriteExplanatorySubmitError = true;
        return;
      }

      let penaltyType = "";
      let penaltyId = "";
      if (this.record.ubp_id !== null) {
        penaltyId = this.record.ubp_id;
        penaltyType = "fine";
      } else if (this.record.foul_id !== null) {
        penaltyId = this.record.foul_id;
        penaltyType = "foul";
      }

      this.$store
        .dispatch("personalEmployee/writeExplanatory", {
          penaltyId,
          penaltyType,
          files: this.modalWriteExplanatoryFormDataFiles,
          text: this.explanatoryTextLocal,
        })
        .then((result) => {
          if (result.response.success) {
            this.record.explanatory.value = "explanatory";
            this.isShowWriteExplanatoryModal = false;
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.discipline-explanatory-cell {
  height: 100%;
  line-height: 13px;
  display: flex;
  align-items: center;
  font-size: 13px;
  padding: 10px !important;
  -webkit-transition: font 0.3s ease;
  transition: font 0.3s ease;

  &-need-write {
    background: #ffffff;

    @media screen and (max-width: 700px) {
      margin: 0 auto 0 0 !important;
    }
  }
}
.m-show-explanatory {
  position: relative;

  &-close {
    position: absolute;
    cursor: pointer;
    top: 12px;
    right: 10px;
  }

  &-title {
    font-weight: 500;
    font-size: 18px;
    line-height: 120%;

    @media screen and (max-width: 700px) {
      font-size: 15px;
    }
  }

  &-loader {
    margin-top: 15px;
    display: flex;
    font-size: 32px;
    justify-content: center;
    color: #ff238d;
  }

  &-fullname {
    margin-top: 17px;
    font-weight: 500;
    font-size: 13px;
    line-height: 21px;

    & span {
      color: #8e9cbb;
    }

    @media screen and (max-height: 700px) {
      display: none;
    }

    &-mobile {
      display: none;
      margin-top: 0;

      @media screen and (max-height: 700px) {
        display: block;
      }
    }
  }

  &-request-header {
    font-size: 13px;
    line-height: 120%;
    margin-top: 3px;

    @media screen and (max-height: 700px) {
      display: none;
    }

    &-mobile {
      display: none;

      @media screen and (max-height: 700px) {
        display: block;
      }
    }
  }

  &-content {
    margin-top: 20px;
    max-height: 520px;
    width: calc(100% + 9px);
    overflow-y: auto;
    position: relative;

    &-shadow-top {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 10;
      opacity: 0;
      height: 30px;
      width: 100%;
      -webkit-transition: 0.2s;
      transition: 0.2s;

      &-active {
        opacity: 1;
        background: -webkit-gradient(
          linear,
          left bottom,
          left top,
          color-stop(16.13%, rgba(255, 255, 255, 0)),
          color-stop(100%, #ffffff)
        );
      }
    }

    &-shadow-bottom {
      position: absolute;
      background: transparent;
      bottom: 0;
      left: 0;
      height: 30px;
      width: 100%;
      opacity: 0;
      -webkit-transition: 0.2s;
      transition: 0.2s;

      &-active {
        opacity: 1;
        background: linear-gradient(180deg, rgba(255, 255, 255, 0) 16.13%, #ffffff 100%);
      }
    }

    @media screen and (max-width: 700px) {
      max-height: calc(100vh - 190px);
    }

    &-mr {
      margin-right: 9px;
    }

    &::-webkit-scrollbar {
      width: 4px;
      height: 100%;
    }

    &::-webkit-scrollbar-thumb {
      background: $color-secondary;
      border-radius: 4px;
    }

    &::-webkit-scrollbar-track {
      background: $color-border-alt;
      border-radius: 4px;
    }

    &-text {
      font-size: 15px;
      line-height: 150%;

      @media screen and (max-width: 700px) {
        font-size: 13px;
      }
    }

    &-images {
      &-img {
        max-width: 100%;
        margin-top: 11px;
        cursor: pointer;
      }
    }
  }

  &-button-close {
    margin-top: 25px;
    margin-left: auto;

    @media screen and (max-width: 700px) {
      width: 100%;
      position: fixed;
      bottom: 0;
      left: 0;
      border-radius: 0;
      background: #ffffff;
      border-bottom: none;
      border-right: none;
      border-left: none;
    }
  }
}

.m-write-explanatory {
  position: relative;

  &-close {
    position: absolute;
    cursor: pointer;
    top: 12px;
    right: 10px;
  }

  &-content {
    margin: 20px 0 20px 0;
    overflow-y: auto;
    max-height: 626px;
    width: calc(100% + 15px);

    @media screen and (max-width: 700px) {
      margin-bottom: 0;
      width: calc(100% + 10px);
      max-height: calc(100vh - 170px);
    }

    &-shadow-top {
      content: "";
      position: absolute;
      background: transparent;
      top: 0;
      left: 0;
      z-index: 10;
      pointer-events: none;
      height: 30px;
      width: 100%;
      opacity: 0;
      transition: 0.2s;

      &-active {
        opacity: 1;
        background: -webkit-gradient(
          linear,
          left bottom,
          left top,
          color-stop(16.13%, rgba(255, 255, 255, 0)),
          color-stop(100%, #ffffff)
        );
      }
    }

    &-shadow-bottom {
      position: absolute;
      background: transparent;
      bottom: 0;
      pointer-events: none;
      left: 0;
      height: 30px;
      width: 100%;
      opacity: 0;
      transition: 0.2s;

      &-active {
        opacity: 1;
        background: linear-gradient(180deg, rgba(255, 255, 255, 0) 16.13%, #ffffff 100%);
      }
    }

    &::-webkit-scrollbar {
      width: 4px;
      height: 100%;
    }

    &::-webkit-scrollbar-thumb {
      background: $color-secondary;
      border-radius: 4px;
    }

    &::-webkit-scrollbar-track {
      background: $color-border-alt;
      border-radius: 4px;
    }
  }

  &-title {
    font-weight: 500;
    font-size: 18px;
    line-height: 120%;

    @media screen and (max-width: 700px) {
      font-size: 15px;
    }
  }

  &-editor {
    height: 284px;
    margin-right: 15px;

    @media screen and (max-width: 700px) {
      margin-right: 10px;
    }
  }

  &-photos {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;

    @media screen and (max-width: 700px) {
      margin-top: 24px;
      width: calc(100% + 5px);
    }

    &-item {
      display: flex;
      width: 154px;
      margin: 25px 12px 0 0;
      -webkit-animation: fadeIn 1s;
      animation: fadeIn 1s;

      @media screen and (max-width: 700px) {
        margin: 0 14px 18px 0;
        width: 132px;
      }

      &-photo {
        width: 136px;
        object-fit: cover;
        height: 102px;
        border: 1px solid #dfe4ef;
        cursor: pointer;
        box-sizing: border-box;
        border-radius: 6px;

        @media screen and (max-width: 700px) {
          width: 108px;
          height: 81px;
        }
      }

      &-name {
        margin-top: 7px;
        text-align: center;
        font-weight: 500;
        font-size: 12px;
        line-height: 108%;
        padding: 0 0 3px 0;
        white-space: nowrap;
        max-width: 136px;
        overflow: hidden;
        text-overflow: ellipsis;

        @media screen and (max-width: 700px) {
          max-width: 108px;
        }
      }

      &-trash {
        margin-left: 3px;
      }
    }
  }

  &-add-photo {
    background: #ffffff;
    //margin-top: 17px;

    &-photos-empty {
      @media screen and (max-width: 700px) {
        margin-top: 18px;
      }
    }

    @media screen and (max-width: 700px) {
      margin-bottom: 30px;
    }
  }

  &-error-message {
    display: flex;
    align-items: center;
    margin-top: 8px;
    margin-left: 1px;

    @media screen and (max-width: 700px) {
      margin-top: -20px;
    }

    &-text {
      margin-left: 6px;
      font-size: 11px;
      color: #ff238d;
    }
  }

  &-buttons {
    margin-top: 30px;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    @media screen and (max-width: 700px) {
      width: 100%;
      position: fixed;
      bottom: 0;
      left: 0;
    }

    &-cancel {
      @media screen and (max-width: 700px) {
        width: 50%;
        border-radius: 0;
        border-bottom: none;
        border-left: none;
        background: #ffffff;
      }
    }

    &-submit {
      margin-left: 10px;
      @media screen and (max-width: 700px) {
        width: 50%;
        margin-left: 0;
        border-radius: 0;
      }
    }
  }
}

@-webkit-keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>

<style lang="scss">
.viewer-slider-write-explanatory {
  .viewer-prev,
  .viewer-next {
    display: block !important;
  }
}
</style>
